import { render, staticRenderFns } from "./Aside.vue?vue&type=template&id=aebe2a1e&scoped=true"
import script from "./Aside.vue?vue&type=script&lang=js"
export * from "./Aside.vue?vue&type=script&lang=js"
import style0 from "./Aside.vue?vue&type=style&index=0&id=aebe2a1e&prod&lang=scss&scoped=true"
import style1 from "./Aside.vue?vue&type=style&index=1&id=aebe2a1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aebe2a1e",
  null
  
)

export default component.exports